// @core/api/endpoints/platform/get_platform_branding.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PlatformBrandingResponse,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Get platform branding
 * Retrieves the platform's branding configuration including logos, colors, and custom styling. This endpoint is public for displaying branding on login pages.
 * @public This endpoint does not require authentication
 */
export async function GetPlatformBranding(
  platform_id: string,
  options?: RequestOptions
): Promise<PlatformBrandingResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/platforms/:platform_id/branding`;
  requestPath = requestPath.replace(':platform_id', encodeURIComponent(platform_id));
  const requestOptions = { ...options, skipAuth: true };
  return client.get<PlatformBrandingResponse>(requestPath, { ...requestOptions });
}
